import { SidebarSideTypes } from "../../enums/SidebarSideTypes";

const state = () => ({
  isLeftSidebarOpened: true,
  isRightSidebarOpened: false
});

const getters = {
  isLeftSidebarOpened: (state: { isLeftSidebarOpened: any }) =>
    state.isLeftSidebarOpened,
  isRightSidebarOpened: (state: { isRightSidebarOpened: any }) =>
    state.isRightSidebarOpened
};

const mutations = {
  openRightSidebar: (state: { isRightSidebarOpened: boolean }) => {
    state.isRightSidebarOpened = true;
  },

  closeRightSidebar: (state: { isRightSidebarOpened: boolean }) => {
    state.isRightSidebarOpened = false;
  },

  openLeftSidebar: (state: { isLeftSidebarOpened: boolean }) => {
    state.isLeftSidebarOpened = true;
  },
  closeLeftSidebar: (state: { isLeftSidebarOpened: boolean }) => {
    state.isLeftSidebarOpened = false;
  },

  toggleSidebar: (
    state: { isRightSidebarOpened: boolean; isLeftSidebarOpened: boolean },
    payload: string
  ) => {
    if (payload === SidebarSideTypes.RIGHT) {
      state.isRightSidebarOpened = !state.isRightSidebarOpened;
    } else {
      state.isLeftSidebarOpened = !state.isLeftSidebarOpened;
    }
  }
};
export default {
  namespaced: true,
  getters,
  mutations,
  state
};
